import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function Select(props) {
    const [defaultClasee, setDefaultClass] = useState("form-select")
    const {
        name,
        value,
        label,
        options,
        disabled,
        formText,
        isInvalid,
        handleChange,
        setIsOpen,
        setModalId,
        // routes,
        inputMsg,
        defaultValue,
        // eventMsg
    } = props
    const { t } = useTranslation()

    useEffect(() => {
        if (isInvalid) setDefaultClass("form-select is-invalid")
        else setDefaultClass("form-select")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    return (
        <div className="mb-3">
            {
                label !== t("routeLabel") && <label htmlFor="foLabel" className="form-label">{label}</label>
            }
            {
                label === t("routeLabel") && <label htmlFor="foLabel" className="form-label">
                    <div style={{ float: "left", padding: 0, margin: 0 }}>
                        {label}&nbsp;&nbsp;{
                            options.length > 0 && <div
                                style={{ padding: " 0 0" }}
                                className='btn btn-link'
                                onClick={() => {
                                    setModalId("2")
                                    setIsOpen(true)
                                }}
                            >{t("checkPrice")}</div>
                        }
                    </div>
                </label>
            }
            <select
                className={defaultClasee}
                aria-label="Default select example"
                name={name}
                value={value}
                disabled={disabled}
                onChange={handleChange}
                defaultValue={defaultValue}
            >
                <option value={""}>-- {inputMsg} --</option>
                {options && <React.Fragment>
                    {options.map((el, i) => {
                        // console.log(el)
                        return (<option value={el.value} key={i}>{t(el.name)}</option>)
                    })}
                </React.Fragment>}
            </select>
            {formText && <div className="form-text">
                {formText.split("\n").map(e => {
                    return (<div key={e}>{t(e)}</div>)
                })}
            </div>}
            {isInvalid && <div className="invalid-feedback"></div>}
        </div>
    )
}
